import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { AnyAction } from 'redux';
import { useAppSelector } from 'redux/hooks';
import { setModalOpen } from 'redux/shortcuts/reducer';
import { selectShortcuts } from 'redux/shortcuts/selectors';
import { logout } from 'redux/users/actions';

export const useKeyboardShortcuts = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const shortcuts = useSelector(selectShortcuts);

  const openModal = () => dispatch(setModalOpen(true));
  const closeModal = () => dispatch(setModalOpen(false));

  const currentUser = useAppSelector(({ users }) => users.currentUser.data)

  const logoutFromAccount = () => {
    dispatch(logout({ id: currentUser.id }) as unknown as AnyAction)
  }

  useEffect(() => {
    const handleKeyDown = (e: KeyboardEvent) => {
      if ((e.ctrlKey || e.metaKey) && e.key.toLowerCase() === 'l') {
        e.preventDefault();
        openModal();
        return;
      }
      if (e.ctrlKey || e.metaKey) {
        const key = e.key.toUpperCase();
        const shortcut = shortcuts.find((s: any) => s.key === key);
        
        if (shortcut) {
          e.preventDefault();
          if (shortcut.commandType === 'link') {
            navigate(shortcut.link as string)
          } else if (shortcut.commandType === 'logout') {
            logoutFromAccount()
          } else if (shortcut.commandType === 'showTool') {
            document.getElementById(shortcut.toolButtonId as string)?.click()
          } else {
            console.log('Нет такой операции')
          }
          console.log(`Выполняется команда: ${shortcut.command}`);
          // Здесь можно добавить вызов соответствующих функций
          // executeCommand(shortcut.command);
        }
      }
    };

    document.addEventListener('keydown', handleKeyDown);
    return () => document.removeEventListener('keydown', handleKeyDown);
  }, [shortcuts, openModal]);

  return { 
    isModalOpen: useSelector((state: any) => state.shortcuts.isModalOpen),
    setIsModalOpen: (isOpen: boolean) => dispatch(setModalOpen(isOpen)),
    openModal,
    closeModal
  };
};